import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/product-collections", {
	title: "Product Collections List",
	icon: {
		src: <Icon icon="category" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Show all product collections list.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
